<kh-img khA11yHidden class="kh-logo-image" [path]="'LOGO.KH_LOGO_HORIZONTAL_URL' | translate" [alt]="'LOGO.KH_LOGO_ALT' | translate"></kh-img>
